import { render, staticRenderFns } from "./DemoTextEditor.vue?vue&type=template&id=3aef59a6&"
import script from "./DemoTextEditor.vue?vue&type=script&lang=js&"
export * from "./DemoTextEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports